import _omit from 'lodash/omit';

import {
  ACTION_SWITCH_CAMPAIGN_STATUS__REQUEST,
  ACTION_SWITCH_CAMPAIGN_STATUS__SUCCESS,
  ACTION_SWITCH_CAMPAIGN_STATUS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_SWITCH_CAMPAIGN_STATUS__REQUEST:
    case ACTION_SWITCH_CAMPAIGN_STATUS__SUCCESS:
      return null;

    case ACTION_SWITCH_CAMPAIGN_STATUS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
